import React from "react";
import debounce from 'debounce'
import { Route, Link, withRouter } from "react-router-dom";
import LocationComponent from "../location_component";
import BookingAddressMap, { SHOW_BOOKING_ADDRESS_MAP } from './BookingAddressMap';
import ServicesSelectionComponent from "../create_project_2/services_selection_component_2";
import PhotographerSelectionComponent from "../create_project/photographer_selection_component";
import OrderSummaryComponent from "../create_project/order_summary_component";
import ProjectCreatedModal from "../create_project/project_created_modal";
import ContractorCalendar from "../create_project/contractor_calendar_component_container"
import ChooseTimeModal from "../create_project/choose_time_modal";
import { fetchTimeSlots, fetchSettings } from "../../util/settings_api_util";
import SignupAndPaymentModalContainer from "./signup_and_payment_modal_container";
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner.gif";
import {ReactComponent as CloseIcon} from '../../../../assets/images/close-icon.svg'
import AddMoreServicesHomepageModal from "./add_more_services_homepage_modal";
import ServiceChoiceComponent from "../create_project_2/service_choice_component";
import { fetchBundleGroups } from "../../util/bundle_api_utils";
import {formatDatetime} from "../../util/date_util";
import { detectTimezone } from "../../util/timezone_utils"
import { removeFromList, subscribeToList } from "../../util/ad_api_utils";
import { trackPurchase } from "../../util/tracking_utils";
import { applyCoupon } from "../../util/discount_code_api_utils";
import { getCookie, deleteCookie } from "../../util/cookie_utils";
import { fetchUnavailability } from "../../util/project_api_util";
import { destroyUser } from "../../util/users_api_util";
import AddonSubServicesSelectionComponent from "../create_project_2/addon_subservices_selection_component"
import { fetchLocationSubServices } from "../../util/service_api_util";
import ScrollArrows from "../scroll_arrows";

class CreateProjectHomePageModal extends React.Component {
  constructor(props) {
    super(props);

    // Captured at construction: this flow signs the user up mid-checkout, so
    // props.currentUser becomes set before the order completes. Acquisition
    // tracking must only fire for people who started out logged out.
    this.startedLoggedOut = !props.currentUser

    this.state = {
      county: "",
      street: "",
      apartment: "",
      zipcode: "",
      state: "",
      city: "",
      latitude: "",
      longitude: "",
      formatted_address: "",
      note: "",
      currentUser: {},
      user_emails: [],
      photographer: "",
      detected_timezone: "",
      emails: [],
      package_attributes: {},
      selectedSubservices: {},
      currentlySelectedService: null,
      cancelledPackages: {},
      appointments: {},
      selected_service: -1,
      specific_service: -1,
      main_service: {},
      previouslyChosen: {},
      visitedServices: {},
      visitedAppointments: {},
      selected_bundle: {},
      bundle_groups: [],
      discount: 0,
      waiting: false,
      loading: true,
      bundleLoading: true,
      modalOpen: false,
      contractorModalOpen: false,
      chooseTimeModalOpen: false,
      goingBackToAddress: false,
      alacartSelected: true,
      bundleSelected: false, 
      addonSubServices: false,
      new_order_process: true,
      bundleDiscountWith2: 0,
      bundleDiscountWith3: 0,
      bundleDiscountWith4: 0,
      account_credit: this.props.currentUser?.account_credit?.amount,
      account_credit_id: "",
      contractorSearch: "",
      contractorDateSearch: "",
      contractorTimeSearch: "",
      twilight_time: "",
      subModal: "",
      promos: [],
      user: {},
      firm: {},
      project: {},
      errors: [],
      propertyErrors: [],
      summaryErrors: [],
      backendErrors: [],
      time_slots: { "Sunday": {}, "Monday": {}, "Tuesday": {}, "Wednesday": {}, "Thursday": {}, "Friday": {}, "Saturday": {} },
      page: this.props.address ? 2 : 1,
      initialPage: this.props.address ? 2 : 1,
      coupon: {},
      location_pricing: {}
    }

    this.handler = this.handler.bind(this)
    this.setAppointmentTime = this.setAppointmentTime.bind(this)
    this.submitOrder = this.submitOrder.bind(this)
    this.previewOrder = this.previewOrder.bind(this)
    this.deleteSubService = this.deleteSubService.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrevious = this.handlePrevious.bind(this)
    this.debounceFetchContractors = debounce((service, zip, search, date, time, services, appointments, timezone, photographer_index, long_shoot) => this.props.fetchContractors(service, zip, search, date, time, services, appointments, timezone, photographer_index, long_shoot), 500)
    this.onContractorSelect = this.onContractorSelect.bind(this)
    this.onClose = this.onClose.bind(this)
    this.calculatePrice = this.calculatePrice.bind(this)
    this.calculateOriginalPrice = this.calculateOriginalPrice.bind(this)
    this.switchToFreePackage = this.switchToFreePackage.bind(this)
    this.scrollToTop = this.scrollToTop.bind(this)
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';

    this.props.fetchServices().then(response => {
      this.setState({loading: false})
    })

    if (this.props.address){
      const address = this.props.address
      this.setState({
        street: address.steet,
        county: address.county,
        apartment: address.apartment_number,
        zipcode: address.zipcode,
        state: address.state,
        city: address.city,
        longitude: address.longitude,
        latitude: address.latitude,
        formatted_address: address.formatted_address
      })

      detectTimezone(address.latitude, address.longitude)
        .then(detected_timezone => {
          fetchTimeSlots(true, detected_timezone).then(time_slots => {
            this.setState({
              twilight_time: time_slots,
              detected_timezone
            });
          });
        });
     }

    fetchSettings().then(data => {
      this.setState({
        new_order_process: data.new_order_process,
        bundleDiscountWith2: data.bundle_discount_with_2,
        bundleDiscountWith3: data.bundle_discount_with_3,
        bundleDiscountWith4: data.bundle_discount_with_4
      });
    });

    fetchBundleGroups().then(bundle_groups => this.setState({ bundle_groups: bundle_groups, bundleLoading: false }))

    if (this.props.address){
      const address = this.props.address
      this.setState({
        street: address.street,
        county: address.county,
        apartment: address.apartment_number,
        zipcode: address.zipcode,
        state: address.state,
        city: address.city,
        longitude: address.longitude,
        latitude: address.latitude,
        formatted_address: address.formatted_address
      })

      detectTimezone(address.latitude, address.longitude)
        .then(detected_timezone => {
          fetchTimeSlots(true, detected_timezone).then(time_slots => {
            this.setState({
              twilight_time: time_slots,
              detected_timezone
            });
          });
        });
    }

    if (this.props.location.pathname.split("/")[1] === "referral"){
      applyCoupon(this.props.location.pathname.split("/")[2]).then(coupon => {
        if (coupon?.id) {
          this.setState({coupon: coupon})
        }
      })
    } else {
      // Picked up from the "Get 20% Off" lead-gen forms (see initial_info.jsx) —
      // lets a brand-new visitor's discount auto-apply here later without
      // needing an account yet or digging the code back out of their email.
      const pendingDiscountCode = getCookie("pending_discount_code")
      if (pendingDiscountCode) {
        applyCoupon(pendingDiscountCode).then(coupon => {
          if (coupon?.id) {
            this.setState({coupon: coupon})
            deleteCookie("pending_discount_code")
          }
        })
      }
    }

    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  componentDidUpdate(_, prevState) {
    if (prevState.page !== this.state.page) {
      this.scrollToTop()
    }

    if (prevState.county !== this.state.county) {
      if (this.state.county != "") {
        const locationKey = this.state.county && this.state.state ? `${this.state.county}, ${this.state.state}` : this.state.county
        fetchLocationSubServices(locationKey).then(location_pricing => {
          this.setState({ location_pricing: location_pricing })
        })
      } else {
        this.setState({ location_pricing: {} })
      }
    }

    if (prevState.contractorSearch !== this.state.contractorSearch) {
      this.debounceFetchContractors(this.state.selected_service, this.state.zipcode, this.state.contractorSearch, this.state.contractorDateSearch, this.state.contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot)
    }

    if (((prevState.contractorDateSearch !== this.state.contractorDateSearch || prevState.contractorTimeSearch !== this.state.contractorTimeSearch) && !this.state.waiting)) {
      this.setState({ waiting: true })
      this.props.fetchContractors(this.state.selected_service, this.state.zipcode, this.state.contractorSearch, this.state.contractorDateSearch, this.state.contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot).then(() => { this.setState({ waiting: false }) })
    }

    if (JSON.stringify(Object.keys(prevState.package_attributes || {}).sort()) !== JSON.stringify(Object.keys(this.state.package_attributes || {}).sort())) {
      const package_attributes_keys = Object.keys(this.state.package_attributes || {})
      if (package_attributes_keys.length > 3 && this.state.long_shoot === null) {
        const requiredTitles = ["Floor Plans", "Video", "Photography", "Drone"];
        const serviceTitles = package_attributes_keys.map(s => this.props.services[s]?.title) || [];
        const hasAllRequired = requiredTitles.every(title => serviceTitles.includes(title));

        if (hasAllRequired) {
          this.setState({ long_shoot: true })
        }
      }

      if (this.state.long_shoot) {
        const requiredTitles = ["Floor Plans", "Video", "Photography", "Drone"];
        const serviceTitles = package_attributes_keys.map(s => this.props.services[s]?.title) || [];
        const hasAllRequired = requiredTitles.every(title => serviceTitles.includes(title));

        if (!hasAllRequired) {
          this.setState({ long_shoot: null })
        }
      }
    }
  }

  switchToFreePackage(){
    let newState = Object.assign({}, this.state.package_attributes);
    let newStateSubservices = Object.assign({}, this.state.selectedSubservices);

    let old_sub_service = "";
    let new_sub_service = null;

    outerLoop:
    for (const service of Object.values(this.props.services)) {
      for (const sub_service of service.subServices) {
        if (sub_service.promo) {
          new_sub_service = sub_service;
          break outerLoop;
        }
      }
    }

    if (new_sub_service && newState[new_sub_service.service_id] && newState[new_sub_service.service_id]["package_sub_services_attributes"] && Object.values(newState[new_sub_service.service_id]["package_sub_services_attributes"]).length > 0){

      //assumes only one sub-service attached to the main service
      const old_sub_service_id = Object.values(newState[new_sub_service.service_id]["package_sub_services_attributes"])[0].sub_service_id

      delete newState[new_sub_service.service_id]["package_sub_services_attributes"][old_sub_service_id]
      delete newStateSubservices[old_sub_service_id]

      newState[new_sub_service.service_id]["package_sub_services_attributes"][new_sub_service.id] = { sub_service_id: new_sub_service.id }
      newStateSubservices[new_sub_service.id] = new_sub_service

      this.setState({ package_attributes: newState, selectedSubservices: newStateSubservices})
    }
  }

  scrollToTop() {
    setTimeout(() => {
      const container = this.modalContentRef.current
      if (container) container.scrollTop = 0
    }, 100)
  }

  anyServiceSelected() {
    return Object.keys(this.state.selectedSubservices).length > 0
  }

  handleNext() {
    this.setState({ errors: [], summaryErrors: [] })

    let errors = []

    if (this.state.page === 0){
      if (!this.state.alacartSelected && !this.state.bundleSelected){
        errors.push("Please select an option before continuing")
      }
    }
    if (this.state.page === 1) {
      if (this.state.street === "") {
        errors.push([1, "Address must be selected from dropdown"])
      }

      if (this.state.city === "") {
        errors.push([2, "City name can't be blank"])
      }

      if (this.state.state === "") {
        errors.push([3, "State can't be blank"])
      }

      if (this.state.zipcode === "") {
        errors.push([4, "Zipcode can't be blank"])
      }
    }

   if (this.state.page === 2) {
      if ((!this.anyServiceSelected() && this.state.alacartSelected) || Object.values(this.state.package_attributes).length === 0) {
        if (!this.anyServiceSelected() && this.state.alacartSelected){
          errors.push("Please select a service before continuing")
        } else {
          errors.push("Please select at least one package for your service before continuing")
        }
      }
    }

    if (this.state.page === 4) {
      if (!this.state.appointments[this.state.selected_service]) {
        errors.push("You must select an appointment time before continuing")
      }
    }

    if (errors.length > 0 && this.state.page === 1) {
      this.setState({ propertyErrors: errors })
    } else if (errors.length > 0) {
      this.setState({ summaryErrors: errors })
    } else {
      if (this.state.page === 1 && this.state.goingBackToAddress) {
        this.setState({ page: 6, errors: [], summaryErrors: [], propertyErrors: [] })
        // this.debouceScrollTo('#scrollToHere')
      } else if(this.state.page === 1){
        this.setState({
          page: 2,
          errors: [],
          summaryErrors: [],
          propertyErrors: []
        }, () => {
          this.scrollToTop();

          detectTimezone(this.state.latitude, this.state.longitude)
            .then(detected_timezone => {
              fetchTimeSlots(true, detected_timezone).then(time_slots => {
                this.setState({
                  twilight_time: time_slots,
                  detected_timezone
                });
              });
            });
        });
      } else {
        if (this.state.page === 4 || this.state.page === 2 || (this.state.page === 3 && this.state.new_order_process)) {
          if (Object.values(this.state.appointments).length === Object.values(this.state.package_attributes).length) {
            if (this.state.new_order_process){
              if (Object.values(this.state.visitedServices).length < Object.values(this.state.package_attributes).length) {
                const selectedService = Object.keys(this.state.package_attributes)
                  .map(serviceId => ({
                    id: serviceId,
                    sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
                  }))
                  .filter(service => !this.state.visitedServices[service.id]) // Exclude visited services
                  .reduce((lowest, service) => (service.sort_order < lowest.sort_order ? service : lowest), { sort_order: Infinity })
                  .id || null;


                const updatedVisitedServices = {
                  ...this.state.visitedServices,
                  [selectedService]: true
                };

                this.setState({
                  selected_service: selectedService, currentlySelectedService: this.props.services[selectedService], visitedServices: updatedVisitedServices
                })
              
              }
              else if (this.state.page === 2){
                this.setState({ page: 3 })
              } else {
                this.setState({ page: 6, errors: [], summaryErrors: [], propertyErrors: [], currentlySelectedService: null, selected_service: -1 })
              }
            } else{
              this.setState({ page: this.state.page === 2 ? this.state.page + 4 : this.state.page + 2, errors: [], summaryErrors: [], propertyErrors: [], currentlySelectedService: null, selected_service: -1 })
            }
          }
          else {
            if (this.state.page != 2 || (this.state.page === 2 && !this.state.new_order_process)){
              let selected_service = "";
              let appointment_time = "";
              if (Object.values(this.state.package_attributes).length - Object.values(this.state.appointments).length > 1) {
                selected_service = parseInt(Object.keys(this.state.package_attributes).find(n => !this.props.services[n].twilight && !Object.keys(this.state.appointments).includes(n)))
              } else {
                selected_service = parseInt(Object.keys(this.state.package_attributes).find(n => !Object.keys(this.state.appointments).includes(n)))
              }
              if (Object.values(this.state.appointments).length > 0) {
                appointment_time = Object.values(this.state.appointments).find(n => !this.props.services[n.service_id].twilight)?.appointment_time ? new Date(Object.values(this.state.appointments).find(n => !this.props.services[n.service_id].twilight)?.appointment_time) : ""
              }
              let contractorDateSearch = appointment_time || "";
              let contractorTimeSearch = appointment_time ? appointment_time.getHours() + (appointment_time.getMinutes() / 60) : ""
              if (this.props.services[selected_service].twilight && appointment_time) {
                const weekday = formatDatetime(appointment_time, 'dddd')
                contractorTimeSearch = Object.keys(this.state.twilight_time[weekday])[0]
              }

              // If an existing contractor can already serve the new service, skip page 4 entirely
              const newServiceObj = this.props.services[selected_service]
              if (newServiceObj && !newServiceObj.twilight) {
                const existingAppt = Object.values(this.state.appointments).find(appt => {
                  if (!appt.contractor?.services || appt.service_id == selected_service) return false
                  if (this.props.services[appt.service_id]?.twilight) return false
                  const apptTime = appt.appointment_time instanceof Date ? appt.appointment_time : new Date(appt.appointment_time)
                  if (!(apptTime > new Date() || this.state.added_appointment_time_in_past)) return false
                  return appt.contractor.services.some(s => s.id == selected_service)
                })

                if (existingAppt) {
                  const autoContractor = existingAppt.contractor
                  const autoDate = existingAppt.appointment_time
                  let newPackageState = Object.assign({}, this.state.package_attributes)
                  let newAppointmentState = Object.assign({}, this.state.appointments)
                  let newVisitedAppointmentState = Object.assign({}, this.state.visitedAppointments)
                  let newMainService = Object.assign({}, this.state.main_service)

                  let contractor_service_ids = {}
                  autoContractor.services.forEach(s => { contractor_service_ids[s.id] = true })

                  Object.keys(this.state.package_attributes).forEach(pkgSvcId => {
                    if (contractor_service_ids[pkgSvcId] && !this.props.services[pkgSvcId].twilight) {
                      if (!this.state.appointments[pkgSvcId]) {
                        const svcIdNum = parseInt(pkgSvcId)
                        newAppointmentState[pkgSvcId] = { service_id: svcIdNum, contractor: autoContractor, appointment_time: autoDate }
                        newVisitedAppointmentState[pkgSvcId] = true
                        newPackageState[pkgSvcId] = { ...newPackageState[pkgSvcId], appointment_time: autoDate, contractor_id: autoContractor.id, service_id: svcIdNum }
                      }
                    }
                  })

                  newMainService[autoContractor.id] = selected_service

                  const svcIdNum = parseInt(selected_service)
                  newAppointmentState[selected_service] = { service_id: svcIdNum, contractor: autoContractor, appointment_time: autoDate }
                  newVisitedAppointmentState[selected_service] = true
                  newPackageState[selected_service] = { ...newPackageState[selected_service], appointment_time: autoDate, contractor_id: autoContractor.id, service_id: svcIdNum }

                  const allAppointmentsFilled = Object.keys(newAppointmentState).length === Object.keys(this.state.package_attributes).length

                  if (allAppointmentsFilled) {
                    this.setState({
                      package_attributes: newPackageState,
                      appointments: newAppointmentState,
                      main_service: newMainService,
                      visitedAppointments: newVisitedAppointmentState,
                      page: 6,
                      errors: [], summaryErrors: [], propertyErrors: [],
                      selected_service: -1,
                      waiting: false
                    })
                  } else {
                    const nextUnvisited = Object.keys(newPackageState)
                      .map(serviceId => ({ id: serviceId, sort_order: this.props.services[serviceId]?.sort_order || 100 }))
                      .filter(service => !newVisitedAppointmentState[service.id])
                      .reduce((lowest, service) => service.sort_order < lowest.sort_order ? service : lowest, { sort_order: Infinity })
                    const nextId = nextUnvisited.sort_order !== Infinity ? nextUnvisited.id : null
                    if (!nextId) {
                      this.setState({
                        package_attributes: newPackageState,
                        appointments: newAppointmentState,
                        main_service: newMainService,
                        visitedAppointments: newVisitedAppointmentState,
                        page: 6,
                        errors: [], summaryErrors: [], propertyErrors: [],
                        selected_service: -1,
                        waiting: false
                      })
                    } else {
                      this.setState({
                        package_attributes: newPackageState,
                        appointments: newAppointmentState,
                        main_service: newMainService,
                        visitedAppointments: newVisitedAppointmentState,
                        selected_service: nextId,
                        page: 4,
                        waiting: true
                      })
                      this.props.fetchContractors(nextId, this.state.zipcode, this.state.contractorSearch, contractorDateSearch, contractorTimeSearch, Object.keys(newPackageState), Object.keys(newAppointmentState), this.state.detected_timezone, null, this.state.long_shoot).then((contractors) => {
                        if (Object.values(contractors.contractors).length === 0) {
                          this.setState({ contractorDateSearch: "", contractorTimeSearch: "", waiting: false })
                        } else {
                          this.setState({ waiting: false })
                        }
                      })
                    }
                  }
                  return
                }
              }

              this.setState({ selected_service: selected_service, waiting: true, errors: [], summaryErrors: [], propertyErrors: [], contractorDateSearch: contractorDateSearch, contractorTimeSearch: contractorTimeSearch, page: this.state.page === 3 ? 4 : this.state.page})
              this.props.fetchContractors(selected_service, this.state.zipcode, this.state.contractorSearch, contractorDateSearch, contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot).then((contractors) => {
                if (Object.values(contractors.contractors).length === 0) {
                  this.setState({ contractorDateSearch: "", contractorTimeSearch: "", waiting: false })
                } else {
                  this.setState({ waiting: false })
                }
              })
            }

            if (this.state.page === 2) {
              if (this.state.new_order_process && Object.values(this.state.visitedServices).length < Object.values(this.state.package_attributes).length){
                const selectedService = Object.keys(this.state.package_attributes)
                  .map(serviceId => ({
                    id: serviceId,
                    sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
                  }))
                  .filter(service => !this.state.visitedServices[service.id]) // Exclude visited services
                  .reduce((lowest, service) => (service.sort_order < lowest.sort_order ? service : lowest), { sort_order: Infinity })
                  .id || null;


                const updatedVisitedServices = {
                  ...this.state.visitedServices,
                  [selectedService]: true
                };
                  
                this.setState({
                  selected_service: selectedService, currentlySelectedService: this.props.services[selectedService], visitedServices: updatedVisitedServices})
              } else {
                this.setState({ page: 3 })
              }
            }
          }
        } else {
          if (this.state.page < 6){
            this.setState({ page: this.state.page + 1, errors: [], summaryErrors: [], propertyErrors: [] })
          }
        }
        this.scrollToTop()
      }
    }
  }

  handlePrevious(e) {
    if (e) e.preventDefault()
    if (this.state.page === 6) {
      if (this.state.new_order_process){
        const sorted_visited_appointments = Object.keys(this.state.visitedAppointments).map(serviceId => ({
          id: serviceId,
          sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
        })).sort((a, b) => a.sort_order - b.sort_order)

        if (sorted_visited_appointments.length === 0) {
          this.setState({ page: 2, selected_service: -1, currentlySelectedService: null })
          return
        }
        let selected_service = sorted_visited_appointments[sorted_visited_appointments.length - 1].id

        this.setState({page: this.state.page - 2, selected_service: selected_service})
      } else {
      if (this.state.currentlySelectedService || this.state.bundleSelected){
        this.setState({ page: this.state.page - 2, errors: [], summaryErrors: [], propertyErrors: [] })
        this.scrollToTop()
      } else {
        this.setState({ page: this.state.page - 4, errors: [], summaryErrors: [], propertyErrors: [] })
        this.scrollToTop()
      }
     }
    } else if (this.state.page === 0){
      this.props.openStartModal()
    } else if (this.state.page === 4 && !this.state.addonSubServices && this.state.bundleSelected) {
      this.setState({page: this.state.page - 2, errors: [], summaryErrors: [], propertyErrors: []})
      this.scrollToTop()
    } else if (this.state.page === 4 && this.state.alacartSelected) {
      if (this.state.new_order_process){
        const current_service = this.state.selected_service
        const current_appointment = this.state.appointments[current_service]?.appointment_time
        const current_contractor_id = this.state.appointments[current_service]?.contractor_id
        const selected_service = Object.values(this.state.appointments).find(appointment => (appointment.appointment_time != current_appointment || appointment.contractor_id != current_contractor_id) && this.state.visitedAppointments[appointment.service_id])

        if (selected_service){
          const updatedVisitedAppointments = { ...this.state.visitedAppointments };
          const shared_service_ids = Object.values(this.state.appointments)
            .filter(appointment => appointment.appointment_time === current_appointment && appointment.contractor_id === current_contractor_id)
            .map(appointment => appointment.service_id)
          shared_service_ids.forEach(service_id => delete updatedVisitedAppointments[service_id])
          this.setState({
            selected_service: selected_service.service_id,
            visitedAppointments: updatedVisitedAppointments
          })
        } else {
        const visitedIds = Object.keys(this.state.visitedServices)
          .map(serviceId => ({
            id: serviceId,
            sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
          }))

        const sortedVisitedServices = visitedIds.sort((a, b) => a.sort_order - b.sort_order);
        const previousServiceId = sortedVisitedServices[sortedVisitedServices.length - 1]?.id

        this.setState({
          selected_service: previousServiceId,
          currentlySelectedService: this.props.services[previousServiceId],
          visitedAppointments: {},
          page: 2
        })
       }
      } else{
        this.setState({ page: 2, errors: [], summaryErrors: [], propertyErrors: [], selected_service: -1, currentlySelectedService: null })
        this.scrollToTop()
      }
    } else if (this.state.page === 2 && this.state.currentlySelectedService) {
      if (this.state.new_order_process && Object.values(this.state.visitedServices).length > 1){
        const visitedIds = Object.keys(this.state.visitedServices)
          .map(serviceId => ({
            id: serviceId,
            sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
          }))

        const sortedVisitedServices = visitedIds.sort((a, b) => a.sort_order - b.sort_order);

        const currentServiceIndex = sortedVisitedServices.findIndex(service => service.id === this.state.selected_service);

        const previousServiceId = sortedVisitedServices[currentServiceIndex - 1]?.id 
        const updatedVisitedServices = { ...this.state.visitedServices };
        delete updatedVisitedServices[this.state.selected_service];
        

        if (currentServiceIndex === 0) {
          this.setState({ errors: [], selected_service: -1, currentlySelectedService: null, propertyErrors: [], summaryErrors: [], visitedServices: {} })
        } else {
          this.setState({
            selected_service: previousServiceId,
            currentlySelectedService: this.props.services[previousServiceId],
            visitedServices: updatedVisitedServices
          });
        }
      } else {
      this.scrollToTop()
      this.setState({ errors: [], selected_service: -1, currentlySelectedService: null, summaryErrors: [], propertyErrors: [], visitedServices: {} })
      }
    } else {
      this.setState({ page: this.state.page - 1, errors: [], summaryErrors: [], propertyErrors: [] })
      this.scrollToTop()
    }
  }

  deleteSubService(sub_service) {
    let newState = Object.assign({}, this.state.package_attributes);
    let newStateSubservices = Object.assign({}, this.state.selectedSubservices);
    let newStateAppointments = Object.assign({}, this.state.appointments);
    let newStateVisitedServices = Object.assign({}, this.state.visitedServices);
    let currentlySelectedService = this.state.currentlySelectedService

    delete newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]
    delete newStateSubservices[sub_service.id]

    if (Object.values(newState[sub_service.service_id]["package_sub_services_attributes"]).length === 0) {
      delete newStateAppointments[sub_service.service_id]
      delete newState[sub_service.service_id]
      delete newStateVisitedServices[sub_service.service_id]
      if (currentlySelectedService?.id === sub_service.service_id){
        currentlySelectedService = null
      }
    }

    this.setState({ package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, visitedServices: newStateVisitedServices, currentlySelectedService: null })
  }

  previewOrder(discount, promo_price, promo_name) {
    let errors = []

    if (this.state.street === "") {
      errors.push([1, "Street can't be blank."])
    }

    if (this.state.city === "") {
      errors.push([2, "City name can't be blank"])
    }

    if (this.state.state === "") {
      errors.push([3, "State can't be blank"])
    }

    if (this.state.zipcode === "") {
      errors.push([4, "Zipcode can't be blank"])
    } else if (this.state.zipcode.length != 5) {
      errors.push([4, "Zipcode must be 5 digits"])
    }

    if (errors.length === 0) {
      this.setState({ promo_price: promo_price, promo_name: promo_name, discount: discount, modalOpen: true })
    } else {
      this.setState({ propertyErrors: errors, summaryErrors: ["Please fill out required fields above."] })
    }
  }

  submitOrder() {
    fetchUnavailability(Object.values(this.state.appointments), this.state.detected_timezone, this.state.street).then((unavailable_appointments) => {
    if (unavailable_appointments.length > 0) {
      let newStateAppointments = this.state.appointments
      let newState = this.state.package_attributes
      unavailable_appointments.forEach((unavailable) => {
        delete newStateAppointments[unavailable]
        delete newState[unavailable]["appointment_time"]
        delete newState[unavailable]["contractor_id"]
      })
      this.props.removeCurrentUser()
      destroyUser(this.state.user.id, "Photographer is no longer available at this appointment time")
      this.props.showToast("Photographer is no longer available at this appointment time")
      this.setState({package_attributes: newState, appointments: newStateAppointments, page: 2, user: {}, modalOpen: false})
    } else {
      let data = {}
      let address_attributes = {}
      let invites = this.state.emails.toString()

 
    address_attributes = { formatted_address: this.state.formatted_address, county: this.state.county, apartment_number: this.state.apartment, city: this.state.city, region: this.state.state, street1: this.state.street, zip_code: this.state.zipcode, longitude: this.state.longitude, latitude: this.state.latitude, timezone: this.state.detected_timezone }
    data = { client_id: this.state.user.id, address_attributes: address_attributes, packages_attributes: this.state.package_attributes, notes: this.state.note, invites: invites, broker_booked: false }

    if (this.state.selected_bundle?.id && !this.state.new_order_process) {
      let bundle_price = 0
      let total_price = 0
      let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

      Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
        total_price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
      })

      this.state.selected_bundle.sub_services.forEach(subservice => {
        bundle_price += parseFloat(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
      })
      bundle_price = bundle_price * (1 - (this.state.selected_bundle.percent_discount / 100))

      total_price += Math.ceil(bundle_price)

      if (this.state.coupon?.id) {
        if (this.state.coupon.percentage) {
          total_price -= parseInt(total_price * this.state.coupon.amount / 100)
        } else {
          if (this.state.coupon.amount > price) {
            total_price = 0
          } else {
            total_price -= parseInt(this.state.coupon.amount)
          }
        }
      }

      data["discount_bundle_id"] = this.state.selected_bundle.id
      data["bundle_price"] = total_price
    }

    if (this.state.coupon?.id) {
      data["discount_coupon_code"] = this.state.coupon.code
    }
    
    this.setState({page: 9})
    this.props.submitOrder(data).then(({ project }) => {
      if (project.errors) {
        this.props.removeCurrentUser()
        destroyUser(this.state.user.id, project.errors)
        this.setState({backendErrors: project.errors})
        this.scrollToTop()
      } else {
        subscribeToList(this.state.user?.email, "7070d09e-19b7-400b-8a58-5babcfdb2245")
        removeFromList(this.state.user?.email, "homepage_ad")
        // LinkedIn Lead Gen List
        removeFromList(this.state.user?.email, "11857f10-8231-42f8-858c-8259753c0c68")
        if (this.startedLoggedOut) {
          trackPurchase('homepage_booking', this.calculatePrice())
        }
        this.setState({ page: 7, project: Object.values(project)[0], modalOpen: false})
      }
    })
   }})
  }

  handler(newState) {
    return new Promise((resolve, reject) => {
    if (this.state.propertyErrors.length > 0) {
      let errors = []

      const currentState = { ...this.state, ...newState }

      if (currentState.street === "") {
        errors.push([1, "Street can't be blank."])
      }

      if (currentState.city === "") {
        errors.push([2, "City name can't be blank"])
      }

      if (currentState.state === "") {
        errors.push([3, "State can't be blank"])
      }

      if (currentState.zipcode === "") {
        errors.push([4, "Zipcode can't be blank"])
      }

      let combinedState = Object.assign(newState, { propertyErrors: errors, summaryErrors: errors.length > 0 ? ["Please fill out required fields above."] : [] })
      this.setState(combinedState, () => {
        resolve();
      })
    } else {
      const currentState = { ...this.state, ...newState }

      // if (currentState.zipcode.length === 5 && currentState.selected_service !== -1 && (newState.selected_service || newState.zipcode)) {
      //   this.setState({ waiting: true }, () => {
      //     resolve();
      //   })
      //   this.props.fetchContractors(currentState.selected_service, currentState.zipcode, currentState.contractorSearch, currentState.contractorDateSearch, currentState.contractorTimeSearch, Object.keys(currentState.package_attributes), Object.keys(currentState.appointments), this.state.detected_timezone, null, this.state.long_shoot).then(() => this.setState({ waiting: false }))
      // }

      this.setState(newState, () => {
        resolve(); 
      })
     }})
  }

  setAppointmentTime(date, contractor) {
    let newState = this.state.package_attributes
    let newAppointmentState = this.state.appointments
    let newVisitedAppointmentState = this.state.visitedAppointments
    let newMainService = this.state.main_service
    let main = true;
    

    let contractor_service_ids = {}

    contractor.services.forEach(service => {
      contractor_service_ids[service.id] = true
    })

    Object.values(this.state.appointments).forEach(appointment => {
      if (appointment.contractor.id === this.state.appointments[this.state.selected_service]?.contractor?.id && appointment.appointment_time === this.state.appointments[this.state.selected_service]?.appointment_time && appointment.service_id != this.state.selected_service) {
        newAppointmentState[appointment.service_id] = { service_id: appointment.service_id, contractor: contractor, appointment_time: date }
        newVisitedAppointmentState[appointment.service_id] = true
        newState[appointment.service_id]["appointment_time"] = date
        newState[appointment.service_id]["contractor_id"] = contractor.id
        newState[appointment.service_id]["service_id"] = appointment.service_id
      }
    })

    Object.keys(this.state.package_attributes).forEach(package_service_id => {
      if (contractor_service_ids[package_service_id] && !this.props.services[package_service_id].twilight && !this.props.services[this.state.selected_service].twilight) {
        if (!this.state.appointments[package_service_id]) {
          newAppointmentState[package_service_id] = { service_id: package_service_id, contractor: contractor, appointment_time: date }
          newVisitedAppointmentState[package_service_id] = true
          newState[package_service_id]["appointment_time"] = date
          newState[package_service_id]["contractor_id"] = contractor.id
          newState[package_service_id]["service_id"] = package_service_id
        }
      }
    })

    if (main === true && !this.props.services[this.state.selected_service].twilight) {
      newMainService[contractor.id] = this.state.selected_service
    }

    newAppointmentState[this.state.selected_service] = { service_id: this.state.selected_service, contractor: contractor, appointment_time: date }
    newVisitedAppointmentState[this.state.selected_service] = true

    newState[this.state.selected_service]["appointment_time"] = date
    newState[this.state.selected_service]["contractor_id"] = contractor.id
    newState[this.state.selected_service]["service_id"] = this.state.selected_service

    this.setState({ package_attributes: newState, appointments: newAppointmentState, main_service: newMainService, summaryErrors: [], visitedAppointments: newVisitedAppointmentState })
  }

  content() {
    const { page } = this.state

    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)
    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );

    if (page === 0){
      return <ServiceChoiceComponent handleNext={this.handleNext} changeParentState={this.handler} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} homepageModal={true}/>
    }

    if (page === 1) {
      return <>
        <LocationComponent homepageModal={true} changeParentState={this.handler} minimize={false} page={this.state.page} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} coupon={this.state.coupon} mapPreview={SHOW_BOOKING_ADDRESS_MAP && this.startedLoggedOut ? <BookingAddressMap latitude={this.state.latitude} longitude={this.state.longitude} address={this.state.formatted_address} /> : null} />
        </>
    }

    if (page === 2){
      return <ServicesSelectionComponent changeParentState={this.handler} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} previouslyChosen={this.state.previouslyChosen} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} location_pricing={this.state.location_pricing} bundleLoading={this.state.bundleLoading} loading={this.state.loading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} currentlySelectedService={this.state.currentlySelectedService} homepage={true} new_order_process={this.state.new_order_process} coupon={this.state.coupon}/>
    }

    if (page === 3){
      if (this.state.alacartSelected){
        return <ServicesSelectionComponent changeParentState={this.handler} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} previouslyChosen={this.state.previouslyChosen} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} location_pricing={this.state.location_pricing} currentlySelectedService={this.state.currentlySelectedService} loading={this.state.loading} bundleLoading={this.state.bundleLoading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} homepage={true} new_order_process={this.state.new_order_process} coupon={this.state.coupon}/>
      } else {
        return <AddonSubServicesSelectionComponent location_pricing={this.state.location_pricing} addonSubservices={this.state.addonSubServices} addonServices={true} changeParentState={this.handler} bundleLoading={this.state.bundleLoading} loading={this.state.loading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} />
      }
    }

    if (page === 4) {
      return <PhotographerSelectionComponent new_order_process={this.state.new_order_process} long_shoot={this.state.long_shoot} visitedAppointments={this.state.visitedAppointments} handleNext={this.handleNext} detected_timezone={this.state.detected_timezone} contractorTimeSearch={this.state.contractorTimeSearch} createProjectHomepage={true} createProjectVersion2={true} contractorDateSearch={this.state.contractorDateSearch} changeParentState={this.handler} previouslyChosen={this.state.previouslyChosen} visitedServices={this.state.visitedServices} page={this.state.page} waiting={this.state.waiting} summaryErrors={this.state.summaryErrors} included_services={this.props.services} main_service={this.state.main_service} zipcode={this.state.zipcode} street={this.state.street} services={this.state.package_attributes} setAppointmentTime={this.setAppointmentTime} selectedService={this.state.selected_service} contractors={this.state.waiting ? {} : this.props.contractors} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} onContractorSelect={this.onContractorSelect} />
    }

    if (page === 5) {
      return ""
    }

    if (page === 6) {
      return <OrderSummaryComponent homepage={true} address={this.props.address} new_order_process={this.state.new_order_process} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} changeParentState={this.handler} location_pricing={this.state.location_pricing} user_emails={this.state.user_emails} coupon={this.state.coupon} modalCheckout={true} checkout={true} emails={this.state.emails} note={this.state.note} page={this.state.page} services={this.props.services} errors={this.state.summaryErrors} promos={this.state.promos} package_attributes={this.state.package_attributes} deleteSubService={this.deleteSubService} account_credit={this.state.account_credit} subservices={this.state.selectedSubservices} appointments={this.state.appointments} previewOrder={this.previewOrder} currentUser={this.props.currentUser} formatted_address={this.state.formatted_address} street={this.state.street} city={this.state.city} state={this.state.state} apartment={this.state.apartment} zipcode={this.state.zipcode} selected_bundle={this.state.selected_bundle} detected_timezone={this.state.detected_timezone} />
    }

    if (page === 7) {
      return ""
    }

    if (page === 10) {
      return ""
    }
  }

  progress() {
    const { page } = this.state
    const step = page

    return [1, 2, 3, 4].map(i => {
      return <div className={`modalFooterProgressItem ${step < 3 && step === i ? 'completed' : ''} ${step >= 3 && step < 6 && i === step - 1 ? 'completed' : ''} ${step === 6 && i === 4 ? 'completed' : ''}`} key={`step-${i}`}>
        {i}
      </div>
    })
  }

  onClose() {
    if (this.state.page <= this.state.initialPage) {
      this.props.onClose()
    } else {
      this.handlePrevious()
    }
  }

  onContractorSelect(contractorId, photographer) {
    if (contractorId) {
      const subModal = <ContractorCalendar photographer={photographer}
        setAppointmentTime={this.setAppointmentTime}
        appointments={this.state.appointments}
        street={this.state.street}
        selectedService={this.state.selected_service}
        changeSelected={this.onContractorSelect}
        handleNext={this.handleNext}
        isLargeScreen={this.props.isLargeScreen}
        homepageModal={true} 
        detected_timezone={this.state.detected_timezone} />
      this.setState({ subModal })
    } else {
      this.setState({ subModal: null })
    }
  }

  calculatePrice(){
    let price = 0

    let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

    Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
      price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
    })

    if (this.state.selected_bundle?.id) {
      let bundle = this.state.selected_bundle
      let bundle_price = 0
      bundle.sub_services.forEach(sub_service => {
        bundle_price += parseFloat(this.state.location_pricing[sub_service.id] ? this.state.location_pricing[sub_service.id].price : sub_service.price)
      })

      bundle_price = bundle_price * (1 - (bundle.percent_discount / 100))

      price += Math.ceil(bundle_price)
    }
    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)
    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );
    if (this.state.new_order_process && selectedEligibleServices.length > 1 && selectedEligibleSubServices.length === Object.values(this.state.selectedSubservices).length){
      if (selectedEligibleServices.length == 2){
        price -= price * this.state.bundleDiscountWith2 / 100
      } else if (selectedEligibleServices.length == 3){
        price -= price * this.state.bundleDiscountWith3 / 100
      } else {
        price -= price * this.state.bundleDiscountWith4 / 100
      }
    }

    if (this.state.coupon?.id) {
      if (this.state.coupon.percentage) {
        price -= price * this.state.coupon.amount / 100
      } else {
        price -= this.state.coupon.amount
      }
    }

    price = Math.round(price)
    price -= this.state.discount

    return price
  }

  calculateOriginalPrice() {
    let price = 0

    let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

    Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
      price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
    })

    if (this.state.selected_bundle?.id) {
      let bundle = this.state.selected_bundle
      let bundle_price = 0
      bundle.sub_services.forEach(sub_service => {
        bundle_price += parseFloat(this.state.location_pricing[sub_service.id] ? this.state.location_pricing[sub_service.id].price : sub_service.price)
      })

      bundle_price = bundle_price * (1 - (bundle.percent_discount / 100))

      price += Math.round(bundle_price)
    }

    price = Math.round(price)

    return price
  }

  render() {

    let icon = ""
    let next_percentage_amount = 0

    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)

    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );

    if (this.state.new_order_process && selectedEligibleSubServices.length === Object.values(this.state.selectedSubservices).length) {
      if (selectedEligibleServices.length == 1) {
        next_percentage_amount = this.state.bundleDiscountWith2
      } else if (selectedEligibleServices.length == 2) {
        next_percentage_amount = this.state.bundleDiscountWith3
      } else if (selectedEligibleServices.length == 3) {
        next_percentage_amount = this.state.bundleDiscountWith4
      }
    }

    const nextTierUpsell = (() => {
      if (!this.state.new_order_process || !this.state.bundleDiscountWith2) return null
      const { bundleDiscountWith2: with2, bundleDiscountWith3: with3, bundleDiscountWith4: with4 } = this.state
      const count = selectedEligibleServices.length
      const currentDiscount = count >= 4 ? with4 : count === 3 ? with3 : count === 2 ? with2 : 0
      for (const [needed, pct] of [[2, with2], [3, with3], [4, with4]]) {
        if (needed > count && pct > currentDiscount) return { servicesNeeded: needed - count, discount: pct }
      }
      return null
    })()

    document.body.style.overflow = 'hidden';

    // let icon = <div key="2" onClick={() => this.props.history.goBack()}><i className="fas fa-arrow-left mainIcon createProjectIcon"></i></div>


    let modal = ""
    let popoutModal = ""

    // if (this.state.modalOpen && this.props.currentUser) {
    //   modal = <CreateProjectModal changeParentState={this.handler} promo_price={this.state.promo_price} firm={this.state.firm} promo_name={this.state.promo_name} sub_broker_client={this.state.sub_broker_client} client_role={this.state.client_role} street={this.state.street} city={this.state.city} state={this.state.state} formatted_address={this.state.formatted_address} apartment={this.state.apartment} zipcode={this.state.zipcode} discount={this.state.discount} account_credit={this.state.account_credit} subservices={this.state.selectedSubservices} isLargeScreen={this.props.isLargeScreen} appointments={this.state.appointments} submitOrder={this.submitOrder} />
    // } else if

    if (this.state.modalOpen) {
      let price = this.calculatePrice()
      modal = <SignupAndPaymentModalContainer changeParentState={this.handler} location_pricing={this.state.location_pricing} backendErrors={this.state.backendErrors} detected_timezone={this.state.detected_timezone} bundle={this.state.selected_bundle} switchToFreePackage={this.switchToFreePackage} submitOrder={this.submitOrder} price={price}/>
    } else if (this.state.contractorModalOpen) {
      modal = <ContractorCalendar photographer={this.state.photographer}
        setAppointmentTime={this.setAppointmentTime}
        appointments={this.state.appointments}
        selectedService={this.state.selected_service}
        street={this.state.street}
        detected_timezone={this.state.detected_timezone}
        changeSelected={() => this.setState({ contractorModalOpen: false })}
        long_shoot={this.state.long_shoot}
        isLargeScreen={this.props.isLargeScreen}
        homepageModal={true} />
    } else if (this.state.chooseTimeModalOpen) {
      modal = <ChooseTimeModal changeParentState={this.handler} homepageModal={true} detected_timezone={this.state.detected_timezone} selectedService={this.state.selected_service} appointments={this.state.appointments} package_attributes={this.state.package_attributes} time_slots={this.props.services[this.state.selected_service]?.twilight ? this.state.twilight_time : this.state.time_slots} contractorDateSearch={this.state.contractorDateSearch} contractorTimeSearch={this.state.contractorTimeSearch} />
    } else if (this.state.page === 7){
      modal = <ProjectCreatedModal project={this.state.project} changeParentState={this.handler} detected_timezone={this.state.detected_timezone} />
    } else if (this.state.subModal){
      modal = this.state.subModal
    } else if (this.state.page === 10) {
      modal = <div className="modal-background create-project-homepage-modal">
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="uploadPhotoModalHeadingGroup">
              <div className="uploadPhotoModalHeading"> Checkout</div>
            </div>
            <div className="orderPreviewModalCategory">
              <div className="settingsComponentHeading">Submitting Order...</div>
              <div className="createProjectPaymentModal">
                <div className="loaderDiv">
                  {/* <Loader
                      type="Oval"
                      color="#4E57AA"
                      height={100}
                      width={100}
                      timeout={30000} //3 secs
                    /> */}
                  <img className="logoImageSpinnerGif" src={LogoSpinner}></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    } else if (this.state.page === 3 && this.state.alacartSelected){
      popoutModal = <AddMoreServicesHomepageModal handleNext={this.handleNext} new_order_process={this.state.new_order_process} percentage_amount={next_percentage_amount} services={Object.values(this.props.services)} orderedPackages={this.state.package_attributes} changeParentState={this.handler}/>
    }

    if (modal) {
      return modal
    }

    let buttons = "";
    let button2 = "";

    if (this.state.page === 0){
      // buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
      //   <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
      //   {/* <div className="signupFormNext" onClick={this.handleNext}>Next Step</div> */}
      // </div>
      buttons = ""
    }

    if (this.state.page === 1) {
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        {/* <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div> */}
        <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
      </div>

      if (this.state.goingBackToAddress) {
        buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
          <div className="signupFormNext orderSummaryButton" onClick={this.handleNext}>Order Summary</div>
        </div>
      }
    } else if (this.state.page === 2) {
      if (this.props.address){
        buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
          {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 && !this.state.currentlySelectedService ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 6, summaryErrors: [] })}>Checkout</div> : this.state.currentlySelectedService ? <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div> : ""}
          <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
        </div>

      } else {
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 && !this.state.currentlySelectedService ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 6, summaryErrors: [] })}>Checkout</div> : <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>}
        <div className="signupFormNext" id="bundleScroll" onClick={this.handleNext}>Next Step</div>
      </div>
      }
    } else if (this.state.page === 3) {
  
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
        <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
      </div>
    } 
      else if(this.state.page === 4) {

      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
        <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
      </div>
    } 
    else if (this.state.page === 6) {
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
        <div className="signupFormNext checkoutModalButton" onClick={() => this.previewOrder(this.state.discount, this.state.promo_price, this.state.promo_name)}>Checkout</div>
      </div>
    }

    let original_price = this.calculateOriginalPrice()
    let price = this.calculatePrice()
    let new_price = this.calculatePrice()
    let savings = original_price - new_price

    return (
      <div className="modal-background create-project-homepage-modal">
        <div className={`orderpreviewModal addServiceModal${this.state.page === 6 ? ' orderSummaryStep' : ''}${SHOW_BOOKING_ADDRESS_MAP && this.startedLoggedOut && this.state.page === 1 ? ' booking-address-map-step' : ''}`} id="createProjectHomepageModal">
          <div className="orderPreviewModalComponent">
            <div style={{ position: "relative", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
              <div className="addServiceModalContent" id={this.state.page === 6 ? "removePaddingTop" : ""} ref={this.modalContentRef}>
                {!this.state.goingBackToAddress && <div onClick={() => this.onClose()} className="modalCloseButton modalCloseButtonHomepage modalCloseButtonCreateProject">
                  <CloseIcon />
                </div>}
                {popoutModal}
                <div>
                  <div id="scrollToHere"></div>
                </div>
                {this.content()}
              </div>
              <ScrollArrows scrollRef={this.modalContentRef} />
            </div>

            {this.state.page !== 7 && <div className="modalFooter modalFooterHomepageCreateProject">
              {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4) && this.state.new_order_process && <div className="homepageModalTotalMobile">{savings > 0 ? <div className="d-flex align-items-center"><div className="newPriceMargin">${new_price.toFixed(0)}</div> <div className="savingsPriceOrderSummary newPriceMargin">$<span className="diagonalStrike">{original_price.toFixed(0)}</span></div></div> : <div className="newPriceMargin"> ${price}</div>}</div>}
              <div className="homepageModalTotalGroup">
                {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4) && this.state.new_order_process && <div className="homepageModalTotal">{savings > 0 ? <div className="d-flex align-items-center"><div className="newPriceMargin">${new_price.toFixed(0)}</div> <div className="savingsPriceOrderSummary newPriceMargin">$<span className="diagonalStrike">{original_price.toFixed(0)}</span></div></div> : <div className="newPriceMargin"> ${price}</div>}</div>}
                <div className="modalFooterProgress modalFooterProgressCreateProject">
                  {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4) && this.state.new_order_process && this.state.bundleDiscountWith2 > 0 && <div className="homepageModalSavings" id="savingsPriceText">{nextTierUpsell ? (nextTierUpsell.servicesNeeded === 1 ? `Add 1 more service to save ${nextTierUpsell.discount}%` : selectedEligibleServices.length === 0 ? `Add ${nextTierUpsell.servicesNeeded}+ services to save ${nextTierUpsell.discount}%` : `Add ${nextTierUpsell.servicesNeeded} more services to save ${nextTierUpsell.discount}%`) : savings > 0 ? `${selectedEligibleServices.length >= 4 ? this.state.bundleDiscountWith4 : selectedEligibleServices.length === 3 ? this.state.bundleDiscountWith3 : this.state.bundleDiscountWith2}% bundle discount applied ✓` : null}</div>}
                </div>
              </div>
              {buttons}
            </div>}
          </div>
          <div className="modalMobilePushup"></div>
        </div>
      </div>
    )
  }
}

export default withRouter(CreateProjectHomePageModal);
